(() => {
  const selector = '[data-luxury-swatch]';

  const enhance = (root = document) => {
    root.querySelectorAll(selector).forEach((swatch) => {
      const link = swatch.querySelector('a');
      if (!link) return;
      link.setAttribute('role', 'button');
      link.setAttribute('aria-pressed', swatch.classList.contains('is-active') ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(selector);
    if (!swatch) return;

    const card = swatch.closest('.product-card--luxury');
    if (!card) return;

    event.preventDefault();

    card.querySelectorAll(selector).forEach((item) => {
      const link = item.querySelector('a');
      const active = item === swatch;
      item.classList.toggle('is-active', active);
      if (link) link.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const productUrl = swatch.dataset.productUrl;
    if (productUrl) {
      card.querySelectorAll('[data-luxury-product-link]').forEach((link) => {
        link.href = productUrl;
      });
    }

    const image = card.querySelector('.product-card__media > a > img');
    if (!image || !swatch.dataset.imageSrc) return;

    card.classList.add('has-luxury-selected-image');
    image.classList.add('is-changing');
    image.src = swatch.dataset.imageSrc;
    if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
    if (swatch.dataset.imageAlt) image.alt = swatch.dataset.imageAlt;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => image.classList.remove('is-changing'));
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance());
  } else {
    enhance();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.(selector)) enhance(node.parentElement || node);
        else enhance(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
